module.exports = __webpack_public_path__ + "img/mulher-segurando-origami-de-coelho.jpg";